import { Mathml } from '@instructure/canvas-rce';
import { getLocale } from '@instructure/quiz-common';
import { debounce } from 'lodash';
var FEATURES = {
  new_math_equation_handling: true,
  explicit_latex_typesetting: false
};
var mathRendererConfig = {
  locale: getLocale()
};
var renderer = new Mathml(FEATURES, mathRendererConfig);
var thereIsNoMathOnThePage = function thereIsNoMathOnThePage() {
  return !renderer.shouldProcess(document.body);
};
export var ensureMathIsReady = function ensureMathIsReady() {
  var timeoutOfMathJaxLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100000;
  if (thereIsNoMathOnThePage()) {
    return Promise.resolve();
  }
  return new Promise(function (resolve, reject) {
    var startTime = Date.now();
    var _checkMathJaxIsLoaded = function checkMathJaxIsLoaded() {
      var _window;
      var hub = (_window = window) === null || _window === void 0 || (_window = _window.MathJax) === null || _window === void 0 ? void 0 : _window.Hub;
      if (hub) {
        resolve(hub);
      } else if (Date.now() - startTime >= timeoutOfMathJaxLoad && !hub) {
        reject(new Error("Timeout after ".concat(timeoutOfMathJaxLoad, "ms: MathJax is not available")));
      } else {
        // Recursively check 50ms if it is exist
        setTimeout(_checkMathJaxIsLoaded, 50);
      }
    };
    _checkMathJaxIsLoaded();
  });
};
export var ensureMathRendered = function ensureMathRendered(hub) {
  if (thereIsNoMathOnThePage()) {
    return Promise.resolve();
  }
  return new Promise(function (resolve) {
    return hub.Queue(['Typeset', hub, document.body, resolve]);
  });
};
export var processNewMathInElem = function processNewMathInElem(elem) {
  renderer.processNewMathInElem(elem || document.body);
};

/*
Rendering the document.body is much more faster because MathJax can optimise
one single big element better than smaller ones where the rendering process always
build up from scratch everytime.

Also debounce needed because of the images based equations trigger re-render and make
the rendering process very slow. This debouncing stuff is for mainly to support our print feature
*/
export default {
  debouncedDocumentRendering: debounce(function () {
    return renderer.processNewMathInElem(document.body);
  }, 500)
};